import { render, staticRenderFns } from "./Index3.vue?vue&type=template&id=34877b29"
import script from "./Index3.vue?vue&type=script&lang=js"
export * from "./Index3.vue?vue&type=script&lang=js"
import style0 from "./Index3.vue?vue&type=style&index=0&id=34877b29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports